import {MAT_DIALOG_DATA, MatDialogClose} from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {ImageCroppedEvent, ImageCropperComponent} from 'ngx-image-cropper';

@Component({
  selector: 'rt-image-cropper',
  templateUrl: './rt-image-cropper.component.html',
  styleUrls: ['./rt-image-cropper.component.scss'],
  standalone: true,
  imports: [ImageCropperComponent, MatDialogClose],
})
export class RtImageCropperComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public injectedData: any) {}
  imageFile: File;

  imageCropped(event: ImageCroppedEvent) {
    const file = event.blob;
    this.imageFile = new File([file], `userProfileImage.png`, {
      type: file.type,
    });
  }
}
